import React, { Component } from 'react';
import { Image, Group, Transformer } from 'react-konva';
import avatar from '../../img/avatar150.png';

class AvatarGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      resizable: true
    }
  }

  componentDidMount() {
    const image = new window.Image();
    image.src = avatar;
    image.onload = () => {
      this.setState({
        image: image
      });
    };

    const stage = this.transform.getStage();
    const avatarImg = stage.findOne(".avatar");

    this.transform.attachTo(avatarImg);
    this.transform.getLayer().batchDraw();
    let shapes = [].slice.call(this.transform.find('Shape'));
    shapes.forEach(item => {
      if (item.className === 'Rect') {
        if (item.name() !== 'rotater') {
          // item.stroke('transparent');
          // item.fill('transparent');
        } else {
          item.borderStroke = 'white';
        }
      } else {
        item.borderStroke = 'white';
        item.borderStrokeWidth = '2';
        item.borderDash = [5,2];
      }
    });
  }



  onMouseOver = (e) => {
    document.body.style.cursor = 'move';
    if (e.target.name() === 'avatar') {
      this.transform.rotateEnabled(true);
      this.transform.borderEnabled(true);
      this.transform.resizeEnabled(true);
      this.transform.getLayer().batchDraw();
      this.transform.forceUpdate();
    }
  }
  onMouseOut = () => {
    document.body.style.cursor = 'default';
  }
  handleClick = (e) => {
    if (e.target.name() === 'avatar') {
      this.transform.rotateEnabled(true);
      this.transform.borderEnabled(true);
      this.transform.resizeEnabled(true);
      this.transform.getLayer().batchDraw();
      this.transform.forceUpdate();
    }
  }

  render() {
    return (
      <Group
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
      >
          <Image
            name="avatar"
            image={this.state.image}
            x={this.props.x}
            y={this.props.y}
            /*width={this.props.sideWidth}*/
            /*height={this.props.sideHeight}*/
            onClick={e => this.handleClick(e)}
            onTap={e => this.handleClick(e)}
            draggable
            onDragEnd={(e) => this.props.setInitialPosition(e.target.x(), e.target.y(), 'avatarPosition')}
            onTransformEnd={(e) => this.props.setInitialPosition(e.target.x(), e.target.y(), 'avatarPosition')}
          />
          <Transformer
            ref={node => {
              this.transform = node;
            }}
            name="avatar-transform"
            rotateAnchorOffset={window.innerWidth > 1120 ? 25 : 50}
            anchorSize={window.innerWidth > 1120 ? 12 : 25}
            borderStroke = {'white'}
            borderStrokeWidth = {2}
            borderDash = {[5,2]}
          />
      </Group>

    );
  }
}
export default AvatarGroup;



// WEBPACK FOOTER //
// ./src/components/AvatarGroup/AvatarGroup.js